import { Product } from '@planone/bau365/util-fair-data';

import { staticExhibitors } from './data-access-exhibitor.static.mocks';
import { staticProducts } from './data-access-product.static.mocks';
import { describedImageMock, linkMock, productGroupMock, topicMock, videoMock } from './generic.mocks';

export const productMock: Product = {
  id: '1',
  exhibitor_id: 'schueco',
  name: 'Produktname',
  description:
    'Platzieren Sie hier eine Beschreibung des Produktes. Beschreiben Sie bspw. was das Produkt ausmacht, welchem Zweck es dient und für welchen Einsatz es am Besten geeignet ist. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
  topics: [topicMock, topicMock],
  product_groups: [productGroupMock, productGroupMock],
  images: [
    {
      description: '',
      resource: 'assets/mock-product-page/productIMG.webp',
      provider: 'RAW',
    },
    {
      description: '',
      resource: 'assets/mock-product-page/galleryIMG1.webp',
      provider: 'RAW',
    },
  ],
  key_facts: [
    'Standard-Aluminium-System für internationale Anforderungen in der Bautiefe 56 mm',
    'Standard-Aluminium-System für internationale Anforderungen in der Bautiefe 56 mm',
    'Standard-Aluminium-System für internationale Anforderungen in der Bautiefe 56 mm',
    'Standard-Aluminium-System für internationale Anforderungen in der Bautiefe 56 mm',
    'Standard-Aluminium-System für internationale Anforderungen in der Bautiefe 56 mm',
    'Standard-Aluminium-System für internationale Anforderungen in der Bautiefe 56 mm',
  ],
  contact_persons: [
    {
      id: '1',
      title: '',
      first_name: 'Ihr',
      name: 'Ansprechpartner',
      job_title: 'Kundenbetreuung',
      email: 'irgendwas@plan.one',
      phone: '08773 18-78889256',
      mobile: '',
      avatar: {
        description: '',
        resource: 'assets/mock-exhibitor-page/contactPersonIMG.webp',
        provider: 'RAW',
      },
    },
    {
      id: '2',
      title: '',
      first_name: 'Ihr',
      name: 'Ansprechpartner',
      job_title: 'Kundenbetreuung',
      email: 'irgendwas@plan.one',
      phone: '08773 18-78889256',
    },
  ],
  videos: [
    {
      provider: 'YOUTUBE',
      resource: 'p2Has_A9THE',
    },
    {
      provider: 'YOUTUBE',
      resource: '0ZqxnIlUX9M',
    },
  ],
  downloads: [
    {
      size: <string>(<unknown>204800), // kann ignoriert werden
      path: 'https://www.schueco.com/resource/blob/8048/68b37e12213c9d37f8e09565e16a5caf/schueco_livlng_rondo_P4411.pdf?domain=de',
    },
    {
      name: 'Aluminium-Fenstersystemen',
      file_name: 'Aluminium-Fenstersystemen',
      size: '20,40',
      path: 'https://www.plan.one',
    },
    {
      name: 'Schüco Livlng Classic',
      file_name: 'Schüco Livlng Classic',
      size: '8,20',
      path: 'https://www.bau365.de',
    },
    {
      name: 'Rondo',
      file_name: 'Schüco Livlng Rondo',
      size: '4,80',
      path: 'https://www.bau365.de',
    },
  ],
  links: [linkMock, linkMock, linkMock, linkMock, linkMock],
  countries: ['Deutschland', 'Schweiz', 'Östereich'],
  exhibition_halls: [
    {
      id: 'test',
      name: 'Testhalle',
      fair_id: 'bau23',
      booths: [
        {
          name: 'Test Booth',
          coordinates: '123',
          area: {
            width: 2,
            depth: 4,
            total: 6,
          },
        },
      ],
    },
  ],
};

export class ProductMockGenerator {
  static elements = 30;
  static mockData = {
    ...productMock,
  };

  static getIds(exhibitor_id: string | undefined = undefined) {
    if (exhibitor_id && Object.keys(staticExhibitors).includes(exhibitor_id)) {
      return Object.values(staticProducts)
        .filter((product: Product) => product.exhibitor_id === exhibitor_id)
        .map((product: Product) => <string>(<unknown>product.id));
    }

    return [...Array(ProductMockGenerator.elements).keys()].map((value) => <string>(<unknown>value));
  }

  static getList(ids: string[] | undefined = undefined, exhibitor_id: string | undefined = undefined) {
    return ProductMockGenerator.getIds(exhibitor_id)
      .filter((id: string) => (ids ? ids.includes(<string>(<unknown>id)) : true))
      .map((id: string) => ProductMockGenerator.getObject(<string>(<unknown>id), exhibitor_id));
  }

  static getPaginatedList(exhibitor_id: string | undefined = undefined) {
    return {
      cursors: {
        next: undefined,
        prev: undefined,
      },
      items: ProductMockGenerator.getList(undefined, exhibitor_id),
    };
  }

  static getObject(id: string, exhibitor_id: string | undefined) {
    if (staticProducts[id]) {
      return staticProducts[id];
    }

    return <Product>{
      ...ProductMockGenerator.mockData,
      id: <string>(<unknown>id),
      exhibitor_id: exhibitor_id ?? '1',
      name: ProductMockGenerator.mockData.name + ' ' + <string>(<unknown>id),
      images: [describedImageMock(), describedImageMock(), describedImageMock()],
      videos: [videoMock, videoMock, videoMock, videoMock, videoMock, videoMock, videoMock],
      contact_persons:
        ProductMockGenerator.mockData.contact_persons?.map((contact) => {
          return {
            ...contact,
            avatar: describedImageMock(),
          };
        }) ?? [],
    };
  }
}
